/**
 * @file store mutations
 * @author wangzhongpeng
 */

export default {
  SET_REGIONLIST(state, arr) {
    state.rawRegionList = arr;
  },
  SET_USER(state, user) {
    state.user = user;
  }
};
